<template>
  <Layout id="app">
    <router-view />
  </Layout>
</template>

<script>
import Layout from './views/layouts/layouts.vue'

import { mapGetters, mapMutations } from 'vuex'

// TODO: Get config from Fauna, not config files...
import { townName } from './config/general'
import { layers as layerConfig } from 'config/mapbox'
import { planMode } from '@/config/mapbox'

export default {
  name: 'App',
  components: {
    Layout
  },
  computed: {
    ...mapGetters('config', {
      townName: 'name'
    })
  },
  created() {
    this.loadConfig()
    this.setTitle({ title: 'EV Consult Prognose Kaart' })
  },
  watch: {
    '$route' (to) {
      this.setTitle({ title: to.meta.title || 'EV Consult Prognose Kaart' })
    }
  },
  methods: {
    ...mapMutations('config', [
      'setConfig'
    ]),
    setTitle({ title }) {
      if (this.townName) {
        title = title + ' - ' + this.townName
      }
      document.title = title
    },
    loadConfig() {
      this.setConfig({
        name: townName,
        layers: layerConfig,
        planmode: planMode
      })
    }
  }
}
</script>


<style lang="scss">

html, body {
  height: 100%;
  font-family: 'Gibson' !important;
  font-size: 14px;
}
html {
  overflow-y: scroll;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
}

</style>
